//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import URI from 'urijs';
import $ from 'jquery';
import utils from '@axisnow/util/utils';
import IndexDBStorageManager from '@axisnow/storage/IndexedDBStorage';
import User from './User';
import Profile from './Profile';
import KeyStore from '@axisnow/crypto/keystore';
import EventEmitter from 'eventemitter3';
import { getURLQueryParams } from '@axisnow/util/Helpers';
import Errors from '@axisnow/util/Errors';
import _ from 'underscore';

var self;
var _storageManager = new IndexDBStorageManager();
var _currentUser;
var _currentProfile;
var _fetchingUser;
var _keyStore = new KeyStore();
var _eventEmitter = new EventEmitter();
var BRANDING = 'AxisNow';

var UserManager = function() {
  self = this;

  _eventEmitter.on('user:updated', function(data) {
    saveUserToStorage(data);
  });
  $.extend(self, _eventEmitter);
};

// Page loads time starts here
// debugger;
//Internal Functions
/**
 * Save User information to user store and Profile info saved in profile collection 
 * @param {*} data 
 * @returns 
 */
function saveUserToStorage(data) {
  data = JSON.parse(JSON.stringify(data));
  return  _storageManager.put(_storageManager.STORE_NAMES.UserStore, data);
}

/**
 * Save profile information profile store collection
 */
function saveProfileToStorage(user_profile_obj) {
   _storageManager.put('ProfileStore', user_profile_obj)
   .then(function(){
   var currentUserId = window.sessionStorage.getItem('currentUser');
    conversionToProfileObject(currentUserId)
   })
 }

 function conversionToProfileObject(id) {
  try {
  self.getUserFromStorage(id).then(function(userObj){
    if (userObj != null) {
       if (userObj.hasOwnProperty('profiles')) {
          userObj.profiles.forEach((profileId,index, arr) => {
          self.getProfileFromStorage(profileId).then(function(profileObj){
              arr[index] = profileObj;
              if ((userObj.profiles.length -1) === index)
              return new User(userObj, _eventEmitter);
          })
        
        })
      }
    }
  })
   } catch (error) {
     console.log('conversionToProfileObject-error',error.message)
  }
 }
 
function removeTokenFromUrl() {
  var uri = new URI(window.location.href);
  var hash = uri.fragment().split('?');
  var uriTemp = new URI(
    window.location.origin || window.location.protocol + '//' + window.location.host,
  );
  uriTemp.search('?' + hash[1]);
  uriTemp.removeSearch('token');
  uri.fragment(hash[0] + uriTemp.search());
  history.replaceState({}, window.document.title, uri.resource());
}

// FSS adds setter/getter for the authData retrieved during this book open session
function setCurrentAuthData(authData) {
  window.sessionStorage.setItem('authData', authData ? JSON.stringify(authData) : '{}');
}

function getCurrentAuthData() {
  return JSON.parse(window.sessionStorage.getItem('authData') || '{}');
}

//Public API

//Convenience method to get patronId based on bookvaultId from storage and get currentUser
UserManager.prototype.getUserFromBookvaultId = function (bookvaultId) {
  return self.getUserFromStorage(bookvaultId, 'bookvaultId');
};

UserManager.prototype.getUserFromStorage = function (id, idType) {
  idType = idType || 'id';
  if (idType == 'id') {
    id = id.toLowerCase();
  }
  return _storageManager
    .get(_storageManager.STORE_NAMES.UserStore, idType, id)
    .then(function(userObj) {
      if (typeof userObj === 'undefined') {
        return null;
      } 
      conversionToProfileObject(id);
      return new User(userObj, _eventEmitter);
    });
};

UserManager.prototype.getProfileFromStorage = function (profileId) {
  
  return _storageManager
    .get('ProfileStore', 'profileid', profileId)
    .then(function(profileObj) {
      if (typeof profileObj === 'undefined') {
        return null;
      }
      return new Profile(profileObj, _eventEmitter);
    });

};

UserManager.prototype.loginUser = function (id, idType) {
  idType = idType || 'id';
  if (idType == 'id') {
    id = id.toLowerCase();
  }
  return _storageManager
    .get(_storageManager.STORE_NAMES.UserStore, idType, id)
    .then(function(userObj) {
      if (typeof userObj === 'undefined') {
        throw new Errors.UserNotFound({
          Title: 'User not found',
        });
      }
      return new User(userObj, _eventEmitter);
    });
};

UserManager.prototype.userFromToken = function () {
  var queryParams = getURLQueryParams();
  var token = queryParams.token;
  var patronID = queryParams.patronId;

  var bookvaultId;
  var self = this;
  _fetchingUser = new Promise(function(resolve, reject) {
    if (typeof token === 'undefined') {
      if (patronID) {
        self
          .getUserFromStorage(patronID)
          .then(function(userObj) {
            _currentUser = userObj;
            resolve(userObj);
          })
          .catch(function(err) {
            resolve(self.getCurrentUser());
          });
      } else if (!_currentUser) {
        var currentUserId = window.sessionStorage.getItem('currentUser');
        if (currentUserId !== null) {
          self
            .getUserFromStorage(currentUserId)
            .then(function(userObj) {
              _currentUser = userObj;
              resolve(userObj);
            })
            .catch(function(err) {
              reject(err);
            });
        } else {
          resolve(self.getCurrentUser());
        }
      } else {
        resolve(_currentUser)
      }
    } else {
      //Since we are trying to get a new user, we remove the current user.
      window.sessionStorage.removeItem('currentUser');
      _currentUser = undefined;

      $.get(utils.getRemoteServerOrigin() + 'auth/' + token)
        .done(function(response) {
          removeTokenFromUrl();
          console.log(response);
          if (response.status.code == 'Success') {
            console.log('Setting bookvaultid retrieved from axis360');
            //Setting patronID to a String to ensure toLowerCase() doesn't fail
            var patronID = response.transactionDetails.patronID + '';
            var currentUserData = {
              bookvaultId: response.transactionDetails.bookVaultID,
              id: patronID.toLowerCase(),
              libraryPrefix: response.transactionDetails.libraryPrefix,
              fndSessionID: response.transactionDetails.fndSesssionID,
              fndLicenseID: response.transactionDetails.fndLicenseID,
              fndContentID: response.transactionDetails.fndContentID,
              titleName: response.transactionDetails.title
            };

              /**
             * Video Signed URL and removed video signed url from response object, once saved in indexed db in order to prevent store in local storage
             */

                if (response.transactionDetails.hasOwnProperty('streamingData')) {

                  currentUserData.videoSignedUrl = response.transactionDetails.streamingData.url
                  currentUserData.itemId = response.transactionDetails.ISBN
                  currentUserData.caption = response.transactionDetails.streamingData.hasOwnProperty('caption') ? response.transactionDetails.streamingData.caption : []
                  currentUserData.videoId = response.transactionDetails.streamingData.videoId
                  delete response.transactionDetails.streamingData;
                }

              /**
               * Current Profile Object
               */
                var currentProfileData = {
                 profileid: response.transactionDetails.profile.id,
                 profileType: response.transactionDetails.profile.type,
                 uuid: response.transactionDetails.bookVaultID,
                 isPrimary: response.transactionDetails.profile.isPrimary
                }
                
            // FSS needs to keep this data for this book session to use productTypeId for License requests
            setCurrentAuthData(response.transactionDetails); // persist for this book open session

            self
              .importUserData(currentUserData, currentProfileData)
              .then(function(currentUser) {
                resolve(currentUser);
              })
              .catch(function(err) {
                reject(err);
              });
          } else {
            console.log('Call to authenticate failed ' + response.status.statusMessage);
            reject(
              new Errors.UnableToLogin(
                'Unable to login',
                'We are unable to login or authenticate your account.',
                'Error',
              ),
            );
          }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
          removeTokenFromUrl();
          if (jqXHR.responseJSON) {
            console.log(jqXHR.responseJSON.status.statusMessage);
          }

          reject(
            new Errors.UnableToLogin(
              'Unable to login',
              'We are unable to login or authenticate your account.',
              'Error',
            ),
          );
        });
    }
  });
  
  return _fetchingUser;
};

UserManager.prototype.getCurrentUser = function(skipLogin) {
  return new Promise(function(resolve, reject) {
    if (!_currentUser && !skipLogin) {
      //Callback funtion for login required event
      var LoginUser = function(id) {
        return self
          .loginUser(id)
          .then(function(user) {
            _currentUser = user;
            window.sessionStorage.setItem('currentUser', _currentUser.id);
            resolve(_currentUser);
          })
          .catch(function(error) {
            var errorObj = new Errors.UnableToLogin(
              'Unable to login.',
              'We are unable to login or authenticate your account.',
              'Error',
            );
            if (error.name == 'UserNotFound') {
              errorObj = new Errors.UserNotFound(
                'Invalid login.',
                'Invalid login. Please try again.',
                'Error',
              );
            }
            self.emit('LoginRequired', LoginUser, errorObj);
          });
      };
      //Login is required as user id is null
      self.emit('LoginRequired', LoginUser);
    } else {
      resolve(_currentUser);
    }
  });
};

UserManager.prototype.getCurrentUserData = function() {
  var self = this;
  return this.getCurrentUser().then(function(user) {
    return self.getUserFromStorage(user.id);
  });
};

UserManager.prototype.getCurrentProfile = function(user) {
  
   if (_currentProfile) {
      return _currentProfile;
   } else {
    return this.getProfileFromStorage(user.currentProfileId);
   }
 
}

UserManager.prototype.importUserData = function (currentUserData, currentProfileData) {
  var self = this;
  return self
    .getUserFromStorage(currentUserData.id)
    .then(function(userObj) {
      _currentUser = userObj;
      _currentProfile = currentProfileData;
      $.extend(_currentUser, currentUserData);
      if (userObj == null) {
        _currentUser = new User(currentUserData);
        /**
         * assign current profile details in userobject
        */
        _currentUser.profiles = [currentProfileData.profileid];
       _currentUser.currentProfileId = currentProfileData.profileid;
       _currentUser.id = _currentUser.id.toLowerCase();
        window.sessionStorage.setItem('currentUser', _currentUser.id);
      } else {
         if (_currentUser.hasOwnProperty('profiles') && Array.isArray(_currentUser.profiles)) {
             _currentUser.profiles.push(currentProfileData.profileid);
             _currentUser.profiles =  _.uniq( _currentUser.profiles);
         } else {
            _currentUser.profiles = [currentProfileData.profileid];
            _currentUser.currentProfileId = currentProfileData.profileid;
         }
       
      }
      console.log(_currentUser.bookvaultId);
      console.log(_currentUser.id)
      window.sessionStorage.setItem('currentUser', _currentUser.id);
      saveUserToStorage(_currentUser);
      saveProfileToStorage(_currentProfile);
      return _currentUser;
    })
    .catch(function(err) {
      throw err;
    });
}
UserManager.prototype.logoutCurrentUser = function() {
  if (_currentUser) {
    window.sessionStorage.removeItem('currentUser');
    _currentUser = undefined;
  }
};

/**
 * FSS needs to keep this data for this book session to use productTypeId for License requests
 * BT keeps the profileID need for Kidzone requests.
 * @param {*} authData 
 */
UserManager.prototype.setCurrentAuthData = function(authData) {
  setCurrentAuthData(authData);
};

/**
 * FSS needs to keep this data for this book session to use productTypeId for License requests 
 * BT keeps the profileID need for Kidzone requests
 * @param {*} authData 
 */

UserManager.prototype.getCurrentAuthData = function() {
  return getCurrentAuthData();
};

export default UserManager;
